export default defineAppConfig({
    ui: {
        drawer: {
          slots: {
            container: 'w-full flex flex-col gap-4 overflow-y-auto overflow-x-hidden p-0 bg-ui',
          }
        },
        tree: {
          slots: {
            linkLeadingIcon: 'hidden'
          },
          compoundVariants: [
            {
              selected: true,
              class: {
                link: [
                  'before:bg-elevated/0'
                ]
              }
            },
            {
              selected: false,
              disabled: false,
              class: {
                link: [
                  'hover:before:bg-elevated/0'
                ]
              }
            }
          ]
        },
        button: {
          compoundVariants: [
            {
              color: 'neutral',
              variant: 'link',
              class: 'text-muted hover:text-(--ui-text-inverted) disabled:text-muted aria-disabled:text-muted focus:outline-none focus-visible:ring-inset focus-visible:ring-2 focus-visible:ring-inverted'
            },
          ],
        },
        slider: {
          slots: {
            track: 'relative bg-(--ui-bg-inverted) overflow-hidden rounded-full grow',
          }
        },
        modal: {
          slots: {
            header: 'flex items-center gap-1.5 p-0 sm:px-6 min-h-10',
            close: 'absolute top-1 end-2'
          }
        },
        colors: {
          primary: 'cirrus-blue',
          secondary: 'slate',
          neutral: 'slate',
        },
    },
})